module.exports = __webpack_public_path__ + "static/media/darkBg.9d8ff2db.png";